import { PasswordBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerResetPasswordStore } from '../state/useBrokerResetPasswordStore';

interface NewPasswordTextBoxProps {
    required?: boolean;
}

export const NewPasswordTextBox: React.FC<NewPasswordTextBoxProps> = ({ required = false }) => {
    const isMobile = isMobileScreen();
    const label = 'New Password';
    const value = useBrokerResetPasswordStore((s) => s.passwordResetInfo.newPassword);
    const setValue = useBrokerResetPasswordStore((s) => s.set_newPassword);

    return (
        <>
            <PasswordBox
                id='newPasswordBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : 'auto'}
            />
        </>
    );
};
